import React from "react";

// Safe fallbacks to prevent "ReferenceError" if your custom animation variables/hooks are globally defined or missing
const safeUseReveal = () => {
  try {
    // @ts-ignore
    if (typeof useReveal === "function") return useReveal();
  } catch (e) {
    // Fallback if useReveal is completely undeclared
  }
  return null;
};

const safeHide = (direction) => {
  try {
    // @ts-ignore
    if (typeof hide === "function") return hide(direction);
  } catch (e) {
    // Fallback if hide is completely undeclared
  }
  return {};
};

export const MissionVision = () => {
  const ref = safeUseReveal();

  return (
    <section
      id="mission-vision"
      className="bg-white py-20 md:py-28 font-sans border-b border-gray-50"
    >
      <div
        ref={ref}
        className="w-full max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 xl:px-24"
      >
        {/* Centered Heading Title Block */}
        <div className="max-w-3xl mx-auto text-center mb-16 md:mb-20">
          
          
          <h2
            data-r
            className="text-4xl md:text-5xl font-extrabold text-[#0F1C35] tracking-tight"
            style={safeHide("up")}
          >
            Mission & Vision
          </h2>
          
          
        </div>

        {/* Content Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-20 items-stretch">
          
          {/* Mission Block */}
          <div 
            data-r 
            style={safeHide("up")} 
            className="flex flex-col p-8 lg:p-10 bg-[#F8F9FA] rounded-2xl border border-gray-100 transition-all duration-300 hover:border-gray-200 shadow-sm"
          >
            <div className="flex items-center gap-3 mb-6">
              <span className="w-8 h-[2px] bg-[#0077b6]" />
              <span className="text-[#0077b6] text-lg font-bold uppercase tracking-[0.2em]">
                Our Mission
              </span>
            </div>
            
           
            
            <p className="text-gray-600 text-base md:text-lg leading-relaxed font-normal">
              

              To empower businesses and entrepreneurs by facilitating strategic connections, supporting market access, promoting investment opportunities, and encouraging long-term economic cooperation between Bangladesh and Italy.
            </p>
          </div>
          
          {/* Vision Block */}
          <div 
            data-r 
            style={safeHide("up")} 
            className="flex flex-col p-8 lg:p-10 bg-[#F8F9FA] rounded-2xl border border-gray-100 transition-all duration-300 hover:border-gray-200 shadow-sm"
          >
            <div className="flex items-center gap-3 mb-6">
              <span className="w-8 h-[2px] bg-[#0077b6]" />
              <span className="text-[#0077b6] text-lg font-bold uppercase tracking-[0.2em]">
                Our Vision
              </span>
            </div>
            
            
            
            <p className="text-gray-600 text-base md:text-lg leading-relaxed font-normal">
              To become the leading platform for economic cooperation, trade, investment, innovation and strategic partnerships between Bangladesh and Italy.
            </p>
          </div>

        </div>
      </div>
    </section>
  );
};

export default MissionVision;